import React from 'react';

const About = () => {
    return (
        <div>
            <h1>About is Comming Soon</h1>
        </div>
    );
};

export default About;